import { css } from '@emotion/css';
import colors from '@/theme/colors';
import { pxToRem } from '@/utils';

const styles = {
  container: css`
    margin-top: 24px;
    padding: 0px 16px;
  `,
  description: css`
    margin-bottom: 24px;
  `,
  textfield: css`
    & .MuiInput-root {
      margin-bottom: 39px;
    }
    & .MuiInput-input {
      color: ${colors.prussian};
    }
  `,
  mapContainer: css`
    margin-top: 20px;
  `,
  map: css`
    padding-top: 8px;
    padding-bottom: 16px;
    height: ${pxToRem(328)};
    & > div {
      border: 1px solid ${colors.silver};
      border-radius: 10px;
    }
    & > div:has(:focus-visible) {
      outline: 2px solid ${colors.focusOutlineColor};
      outline-offset: 2px;
      border-radius: 10px;
    }
    .gm-style-cc,
    .gmnoprint {
      display: none;
    }
  `,
  slider: css`
    .MuiSlider-thumbColorPrimary {
      background: ${colors.white};
    }
    .MuiSlider-track {
      width: 75%;
      background-color: ${colors.leaf};
      border: none;
    }
    .MuiSlider-rail {
      background-color: rgba(120, 120, 128, 0.2);
    }

    & .MuiSlider-thumb.Mui-focusVisible {
      outline: 2px solid ${colors.focusOutlineColor};
      outline-offset: 2px;
    }

    & .MuiSlider-thumb:focus,
    & .MuiSlider-thumb:focus-visible {
      outline: 2px solid ${colors.focusOutlineColor} !important;
      outline-offset: 2px;
    }

    & .MuiSlider-thumb:focus,
    & .MuiSlider-thumb:active,
    & .MuiSlider-thumb:hover {
      outline: none;
    }
  `,
  distanceContainer: css`
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    width: 100%;
    flex: 1;
  `,
  distanceLabel: css`
    display: block;
    font-family: 'Montserrat Regular';
    font-size: ${pxToRem(11)};
    line-height: 1.33;
    color: ${colors.slate};
    margin-bottom: 2px;
  `,
  distanceFieldset: css`
    border: 0;
    margin: 0;
    padding: 0;
    min-inline-size: 0;
  `,
  distanceInput: css`
    margin: 0px 8px 0px 16px;
    .MuiOutlinedInput-root {
      width: ${pxToRem(33)};
      height: ${pxToRem(36)};
    }

    .MuiOutlinedInput-input {
      font-family: 'Montserrat Medium';
      padding: 8px 15px;
      font-size: ${pxToRem(14)};
      line-height: 1.43;
      letter-spacing: -0.4px;
      color: ${colors.prussian};
    }
    .MuiOutlinedInput-root {
      width: ${pxToRem(48)};
    }
    .MuiOutlinedInput-notchedOutline {
      border-color: ${colors.neutralAsh};
    }
  `,
  metricTypeIpunt: css`
    width: ${pxToRem(48)} !important;
    height: ${pxToRem(36)} !important;
    overflow: unset !important;

    .MuiSelect-outlined {
      padding: 8px 3px 8px 11px;
      color: ${colors.prussian};
    }
    .MuiOutlinedInput-notchedOutline {
      border-color: ${colors.neutralAsh};
    }

    .MuiSvgIcon-root {
      color: ${colors.prussian} !important;
    }

    .MuiSelect-select {
      font-family: 'Montserrat Medium';
      font-size: ${pxToRem(14)};
      line-height: 1.43;
      letter-spacing: -0.4px;
      text-overflow: unset !important;
    }

    & > .MuiOutlinedInput-input {
      padding-right: 0px;
    }
    & > .MuiSvgIcon-root {
      right: -2px;
    }
  `,
  metricTypeOption: css`
    padding: 6px 16px !important;
    display: grid !important;
    justify-content: flex-start !important;
  `,
  footer: css`
    display: flex;
    justify-content: flex-end;
    margin-top: 44px;
    margin-bottom: 64px;
    & > div {
      margin-left: 16px;
    }
  `,
  inputAddressError: css`
    .MuiInput-underline:before {
      border-bottom: 1px solid ${colors.dragon};
    }
  `,
  legendContainer: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    padding-bottom: 20px;
  `,
  legend: css`
    display: flex;
    flex-direction: row;
    align-items: center;
  `,
  distanceLegend: css`
    margin: 0;
    padding: 0;
  `,
};

export default styles;
